import { DiscoverFilterPopover } from "./discover-filter-popover";
import { DiscoverSortPopover } from "./discover-sort-popover";

export const DiscoverMainFilter = ({
  isTimePeriodDisabled,
}: {
  isTimePeriodDisabled?: boolean;
}) => {
  return (
    <div className="flex items-center justify-between p-0 text-xs text-muted">
      <div className="flex items-center text-muted">
        <DiscoverFilterPopover {...{ isTimePeriodDisabled }} />
        <DiscoverSortPopover />
      </div>
    </div>
  );
};
